import React from "react";
import { Link } from "react-router-dom";
function Servicesbuttom({ teamImages = [] }) {
  return (
    <div className="our-buttom-section padding-container">
      <div className="page-wrapper">
        <div className="our-buttom-rap">
          <div className="our-buttom">
            <h1>
              OUR TEAM BUILDS IT{" "}
              <span style={{ color: "var(--orange-color)" }}>BEST</span>
            </h1>

            <div className="round-img-section">
              <div className="round-imgs" style={{ position: "relative" }}>
                {teamImages.length > 0 ? (
                  teamImages.map((img, index) => (
                    <div
                      key={index}
                      className="round"
                      style={{
                        left: `${index * 30}px`,
                        position: "absolute",
                        backgroundImage: `url(${img})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        border: "2px solid white",
                      }}
                    ></div>
                  ))
                ) : (
                  <p style={{ fontSize: "0.9rem", color: "#aaa" }}>
                    No team images found
                  </p>
                )}
              </div>

              <div className="discus-btn">
                <Link className="rounded-btn" to="/Contact">
                  LET’S DISCUSS YOUR PROJECT
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Servicesbuttom;
